var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirebasesvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_9_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.543 478.292c19.839 7.985 41.361 12.723 63.959 13.512 30.584 1.069 59.667-5.255 85.667-17.266-31.178-12.25-59.415-30.164-83.514-52.436-15.622 25.011-38.726 44.768-66.112 56.19z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.652 422.11c-55.011-50.878-88.383-124.516-85.563-205.285.092-2.622.23-5.244.393-7.864a142.5 142.5 0 00-74.4.778c-14.686 25.724-23.547 55.239-24.651 86.853C61.58 378.18 110.956 449.47 182.54 478.3c27.386-11.423 50.49-31.155 66.112-56.19z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.653 422.107c12.79-20.468 20.544-44.463 21.447-70.317 2.374-68.006-43.343-126.507-106.618-142.832-.162 2.621-.3 5.242-.392 7.865-2.82 80.768 30.552 154.407 85.563 205.284z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.024 17.799c-36.037 28.87-64.494 66.939-81.712 110.792-9.857 25.119-16.051 52.101-17.859 80.384 63.274 16.325 108.992 74.826 106.618 142.831-.903 25.854-8.68 49.826-21.448 70.318a266.403 266.403 0 0083.514 52.435c62.581-28.928 106.982-91.175 109.553-164.802 1.666-47.702-16.662-90.217-42.56-126.103C371.78 145.7 263.024 17.799 263.024 17.799z",
    fill: "#DD2C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_9_19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebasesvg);
export default __webpack_public_path__ + "static/media/firebasesvg.810176f6979904d2c5a2b8e76e3f2233.svg";
export { ForwardRef as ReactComponent };